import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { VehicleBodyTypeLiterals } from '@trukt/types/Vehicle';
import { Commodity } from '@trukt/types/Commodity';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { CommodityUpdateRequest, CommodityUpdateResponse } from './CommodityService.types';
import { NullableKeys } from '@trukt/types/NullableKeys';

export type CommodityTypesSearchRequest = PaginatedQueryParams;
export type CommodityTypesSearchResponse = PaginatedResults<
  Pick<Commodity, 'type'> & { isDefault: boolean }
>;

export type CommodityDecodeVinRequest = BaseRequest<
  void,
  {
    vins: string[];
  }
>;
export type DecodedVin = {
  bodyClass?: string;
  customType?: VehicleBodyTypeLiterals;
  fuelTypePrimary?: string;
  GVWR?: string;
  make?: string;
  model?: string;
  Series?: string;
  trim2?: string;
  type?: string;
  vehicleType?: string;
  vehicleWeightClass?: {
    label: string;
    value: string;
  };
  vin: string;
  year?: string;
};
export type CommodityDecodeVinResponse = DecodedVin[];

type CommodityBodyRequest = {
  jobGuid: string;
  orderGuid: string;
  commodity: {
    vehicle?:
      | (Required<Pick<NonNullable<Commodity['vehicle']>, 'make' | 'model' | 'year'>> &
          Partial<NullableKeys<Omit<NonNullable<Commodity['vehicle']>, 'make' | 'model' | 'year'>>>)
      | null;
  } & Required<Pick<Commodity, 'type' | 'identifier'>> &
    Partial<NullableKeys<Omit<Commodity, 'type' | 'identifier' | 'vehicle'>>>;
};
export type CommodityCreateRequest = BaseRequest<void, CommodityBodyRequest>;
export type CommodityCreateResponse = { guid: string };

export type CommodityDeleteRequest = BaseRequest<void, void, Pick<Commodity, 'guid'>>;
export type CommodityDeleteResponse = void;

export class CommodityService implements BaseRequestEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  create({ body }: CommodityCreateRequest) {
    return this.instance.post<CommodityCreateResponse>('/commodities', body);
  }

  getById(request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  update({ routeParams, body }: CommodityUpdateRequest) {
    return this.instance.patch<CommodityUpdateResponse>(`/commodities/${routeParams.id}`, body);
  }

  delete({ routeParams }: CommodityDeleteRequest) {
    return this.instance.delete<CommodityDeleteResponse>(`/commodities/${routeParams.guid}`);
  }

  decodeVin(request: CommodityDecodeVinRequest) {
    return this.instance.post<CommodityDecodeVinResponse>('/commodity/decodevins', request.body);
  }

  searchTypes(request: CommodityTypesSearchRequest) {
    return this.instance.get<CommodityTypesSearchResponse>('/commodities/types', {
      params: request,
    });
  }
}
